module EnvironmentVariables {
    export var module = angular.module("EnvironmentVariablesModule", ["ui.bootstrap", "frends-utils", "ui.router"]);
    export const DEFAULT_ENV_NAME = "Default";
    module.config([
        "$stateProvider", "$locationProvider", "$urlRouterProvider", "$urlMatcherFactoryProvider", "$compileProvider", function (
            $stateProvider: ng.ui.IStateProvider,
            $locationProvider: ng.ILocationProvider,
            $urlRouterProvider: ng.ui.IUrlRouterProvider,
            $urlMatcherFactoryProvider: ng.ui.IUrlMatcherFactory,
            $compileProvider: ng.ICompileProvider) {

            // Removes trailing slash before hitting the stateProvider.
            $urlMatcherFactoryProvider.strictMode(false);

            $compileProvider.debugInfoEnabled(false);
            $stateProvider
                .state("environment", {
                    url: "/EnvironmentVariables/List/:environmentName",
                    templateUrl: "EnvironmentVariablesTemplate",
                    controller: "EnvironmentVariablesController as ctrl"
                });
            $locationProvider.html5Mode(true);
            $urlRouterProvider
                .when("/EnvironmentVariables/List", "/EnvironmentVariables/List/" + DEFAULT_ENV_NAME);
        }
    ]);
}